import api from "./api";

const getAll = () => {
  return api.get("/api/service-type/get-all");
};

const save = (serviceType) => {
  return api.post("/api/service-type/save", serviceType);
};

const update = (serviceType) => {
  return api.post("/api/service-type/update", serviceType);
};

const archive = (serviceTypeId) => {
  return api.post("/api/service-type/archive", { serviceTypeId });
};

const ServiceTypeService = {
  getAll,
  save,
  update,
  archive,
};

export default ServiceTypeService;
